import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Down = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.58579 8.58579C1.80474 9.36683 1.80474 10.6332 2.58579 11.4142L14.5858 23.4142C15.3668 24.1953 16.6332 24.1953 17.4142 23.4142L29.4142 11.4142C30.1953 10.6332 30.1953 9.36684 29.4142 8.58579C28.6332 7.80474 27.3668 7.80474 26.5858 8.58579L16 19.1716L5.41421 8.58579C4.63317 7.80474 3.36684 7.80474 2.58579 8.58579Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
    </svg>
  );
};

export default Down;
